import React from 'react';
import { string } from 'prop-types';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './AlertToast.scss';

function AlertToastContainer(props) {
  return (
    <ToastContainer
      position={props.position}
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick={false}
      closeButton={false}
      rtl={false}
      draggable={false}
      pauseOnHover
      className={props.className}
      limit={3}
      transition={Slide}
    />
  );
}

AlertToastContainer.propTypes = {
  className: string,
  position: string
};

export default AlertToastContainer;
